import * as React from "react";
import { GrafferPermissions } from "../../../application/domain/rbac/rbac";
import { GroupPermissionAttached } from "../../../application/domain/group/grp_resource";
import { useRBAC } from "./use-rbac";

export const RBACHidden: React.FC<{
  children?: React.ReactNode;
  target?: GroupPermissionAttached;
  requirePermissions?: GrafferPermissions;
  hiddenChildren?: React.ReactNode;
}> = ({ children, target, requirePermissions, hiddenChildren }) => {
  const hasPermission = useRBAC();

  return (
    <>
      {!hasPermission({
        target,
        requirePermissions,
      }) ? (
        <>{hiddenChildren}</>
      ) : (
        <>{children}</>
      )}
    </>
  );
};
